import React, { ReactNode } from "react";

interface Props {
  children: ReactNode;
  style?: Object;
  key?: string;
}
export const ListTableCol = ({ children, style = {}, key = "" }: Props) => {
  return (
    <div
      className="w-full flex gap-2 items-center p-3"
      style={{
        border: "1px solid lightgrey",
        height: "50px",
        gap: "20px",
        ...style,
      }}
    >
      {children}
    </div>
  );
};
